import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import ImpressumView from '../views/Impressum.vue';
import DatenschutzView from '../views/Datenschutz.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: ImpressumView
  },
  {
    path: '/datenschutz',
    name: 'Datenschutz',
    component: DatenschutzView
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    } else {
      return { top: 0, behavior: 'smooth' };
    }
  }
});

export default router;
